// tslint:disable: no-output-on-prefix
import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from "@angular/core";
import {ITCITenantModalOptions} from "@tci/common";
import {TCITenantComponentInput, TCITenantComponentOutput} from "../ng-tenant/tci-tenant-components";
import {Dialog} from "primeng/primeng";

@Component({
    selector: "ng-app-hamburger-menu-modal",
    templateUrl: "./ng-app-hamburger-menu-modal.component.html",
    styleUrls: ["./ng-app-hamburger-menu-modal.component.css"]
})
export class NgAppHamburgerMenuModalComponent<T> implements OnChanges {
    @Input() visible: boolean;
    @Input() menuOption: ITCITenantModalOptions;
    @Output() onClose: EventEmitter<boolean> = new EventEmitter();

    @Input() tenantInput: TCITenantComponentInput;
    @Output() tenantOutput: TCITenantComponentOutput<T> = new EventEmitter();

    @ViewChild(Dialog) dialog: Dialog;

    dimensions = { height: 0, width: 0 };

    ngOnChanges(changes: SimpleChanges) {
        if (this.menuOption && changes["menuOption"]) {
            const modalType = this.menuOption.getModalType();
            this.dimensions = { height: modalType.getHeight(), width: modalType.getWidth() };
        }
    }

    close() {
        this.onClose.emit(true);
    }

    emitTenantOutput($event: T) {
        this.tenantOutput.emit($event);
    }

    recenter() {
        this.dialog.center();
    }

}
